export enum FormLanguageDetectionStatus {
  detected = 'detected',
  undetermined = 'undetermined',
  notSupported = 'not_supported',
  failed = 'failed',
}
